import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Input, DatePicker, Tooltip, Modal, Select } from 'components';
import { CleanIcon, PrintIcon, TicketIcon, ViewIcon } from 'assets/icons';
import moment from 'moment';
import { Globals, Print, Constants, Colors, checkPermission } from 'utils';
import { OrderService } from 'services';
import ModalViewOrder from './modal-view-order';
import ModalConfirm from './modal-confirm';
import ModalConfirmPayment from './modal-confirm-payment';
import ModalPayment from './modal-payment';
import ModalDelivery from './modal-delivery';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	status: '',
	status_payment: ''
}

declare var window: any;

class Orders extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Fecha',
			'Nº Pedido',
			'Cliente',
			'Detalles del pago',
			'Monto total',
			'Forma de Pago',
			'Método de Entrega',
			'Estatus de pedido',
			'Estatus de pago',
			'Acciones'
		],
		visible_view: false,
		visible_confirm_payment: false,
		item: null,
		visible_confirm: false,
		visible_payment: false,
		visible_delivery: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Pedidos y ventas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await OrderService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.orders.rows,
			last_page: res.orders.count
		});
	}	

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	print = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await OrderService.admin.download({
			order_id: item.id
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}

	getColor = (status: number) => {
		switch(status) {
			case Constants.ORDERS_STATUS.PENDING:
				return Colors.danger;
			break;

			case Constants.ORDERS_STATUS.FINISH:
				return Colors.green;
			break;
		}
	}

	getPaymentColor = (status: number) => {
		switch(status) {
			case Constants.ORDERS_PAYMENT_STATUS.PENDING:
				return Colors.danger;
			break;

			case Constants.ORDERS_PAYMENT_STATUS.ACCEPTED:
				return Colors.green;
			break;

			case Constants.ORDERS_PAYMENT_STATUS.REJECTED:
				return Colors.black;
			break;
		}
	}

	confirmChangeStatus = (item: any) => {
		if (item?.status == Constants.ORDERS_STATUS.PENDING) {
			if (item?.status_payment == Constants.ORDERS_PAYMENT_STATUS.PENDING) {
				Globals.showError("Para cambiar el estatus de la orden debe aceptar el pago");
			}
			else if (item?.status_payment == Constants.ORDERS_PAYMENT_STATUS.ACCEPTED) {
				this.setState({
					visible_confirm: true,
					item
				});
			}
		}
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false,
			item: null
		});
	}

	changeStatus = async () => {
		await this.setState({
			visible_confirm: false
		});
		await OrderService.admin.changeStatus({
			// @ts-ignore
			order_id: this.state.item?.id
		});
		await this.setState({
			item: null
		});
		this.load(true);
	}

	confirmChangePaymentStatus = (item: any) => {
		if (item?.status_payment == Constants.ORDERS_PAYMENT_STATUS.PENDING) {
			this.setState({
				visible_confirm_payment: true,
				item
			});
		}
	}

	onCloseConfirmPayment = () => {
		this.setState({
			visible_confirm_payment: false,
			item: null
		});
	}

	changePaymentStatus = async (status: number) => {
		await this.setState({
			visible_confirm_payment: false
		});
		await OrderService.admin.changePaymentStatus({
			// @ts-ignore
			order_id: this.state.item?.id,
			user_id: this.props.user?.id,
			status
		});
		await this.setState({
			item: null
		});
		this.load(true);
	}

	onClosePayment = () => {
		this.setState({
			visible_payment: false,
			item: null
		});
	}

	onCloseDelivery = () => {
		this.setState({
			visible_delivery: false,
			item: null
		});
	}
	
	render() {
		const { visible_view, visible_confirm, visible_confirm_payment, visible_payment, visible_delivery } = this.state;

		return (
			<div id="admin-shop-orders">
				<Modal
		          className="modal-view-order"
		          visible={ visible_view }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseView() }
		        >
					<ModalViewOrder
						item={ this.state.item }
						onClose={ () => this.onCloseView() }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-view-payment"
		          visible={ visible_payment }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onClosePayment() }
		        >
					<ModalPayment
						item={ this.state.item }
						onClose={ () => this.onClosePayment() }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-view-delivery"
		          visible={ visible_delivery }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseDelivery() }
		        >
					<ModalDelivery
						item={ this.state.item }
						onClose={ () => this.onCloseDelivery() }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-confirm-order"
		          visible={ visible_confirm }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseConfirm() }
		        >
		        	<ModalConfirm
						onConfirm={ () => this.changeStatus() }
						onClose={ () => this.onCloseConfirm() }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-confirm-order"
		          visible={ visible_confirm_payment }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseConfirmPayment() }
		        >
		        	<ModalConfirmPayment
						onConfirm={ (status: number) => this.changePaymentStatus(status) }
						onClose={ () => this.onCloseConfirmPayment() }
					/>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-10">
						<div className="row">
							<div className="col-md-4">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nº pedido o cliente"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-4">
								<DatePicker
									placeholder="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md-4">
								<DatePicker
									placeholder="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.until }
								/>
							</div>
							<div className="col-md-4">
								<Select
									placeholder="Estatus"
									name="status"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.ORDERS_STATUS.PENDING.toString(), label: 'Pendientes' },
										{ value: Constants.ORDERS_STATUS.FINISH.toString(), label: 'Entregados' },
									] } />
							</div>
							<div className="col-md-4">
								<Select
									placeholder="Estatus de Pago"
									name="status_payment"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.status_payment }
									options={ [
										{ value: Constants.ORDERS_PAYMENT_STATUS.PENDING.toString(), label: 'Pendientes' },
										{ value: Constants.ORDERS_PAYMENT_STATUS.ACCEPTED.toString(), label: 'Aprobados' },
										{ value: Constants.ORDERS_PAYMENT_STATUS.REJECTED.toString(), label: 'Rechazados' },
									] } />
							</div>
						</div>
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i?.created_at).format('DD-MM-YYYY') }</td>
								<td>{ i?.number }</td>
								<td>{ i?.user?.full_name }</td>
								<td>
									<button className="btn-ticket" onClick={ () => {
										this.setState({
											visible_payment: true,
											item: i
										});
									} }>
										<img src={ TicketIcon } />
									</button>
								</td>
								<td>{ Globals.formatMiles(i?.total) }</td>
								<td>{ i?.payment?.payment_method?.name || '' }</td>
								<td>
									<button className="btn-ticket" onClick={ () => {
										this.setState({
											visible_delivery: true,
											item: i
										});
									} }>
										<img src={ TicketIcon } />
									</button>
									{ i?.delivery?.delivery_type?.name }
								</td>
								<td className="status" onClick={ () => {
									if (checkPermission(Constants.MODULES.ORDERS,'write')) {
										this.confirmChangeStatus(i);
									}
								} } style={{
									color: this.getColor(i?.status)
								}}>{ i?.status_text }</td>
								<td className="status" onClick={ () => {
									if (checkPermission(Constants.MODULES.ORDERS,'write')) {
										this.confirmChangePaymentStatus(i);
									}
								} } style={{
									color: this.getPaymentColor(i?.status_payment)
								}}>{ i?.status_payment_text }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => {
											e.preventDefault();
											this.setState({
												visible_view: true,
												item: i
											});
										} }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Imprimir">
										<a className="link-icon" href="#" onClick={ (e: any) => this.print(e,i) }>
											<img src={ PrintIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Orders);